import React, { Component } from 'react';
import { Col } from "react-bootstrap";
import { Scatter } from "react-chartjs-2";
//IDEA show this is not used anywhere, but it is necessary for chart zoom!!!
import * as zoom from 'chartjs-plugin-zoom'
import Button from "@material-ui/core/Button";
import { MASTER_DASHBOARD_CHART_TYPE } from "../common/constants";

const printTimeAndResinUsageSet = {
    labels: ["Scatter"],
    datasets: [
        {
            label: 'print',
            backgroundColor: 'rgba(75,192,192,1)',
            data: [],
            borderWidth: 0,
            pointRadius: 2,
        }
    ]
};

export default class PrintDataPrintTimeAndResinUsage extends Component {
    constructor(props) {
        super(props);
    }

    resolveTimeAndResinSet = () => {
        const prints = this.props.prints;
        printTimeAndResinUsageSet.datasets[0].data = prints.map(item => {
            return {
                x: item.totalPrintTime,
                y: item.resinUsage,
            }
        });
    };

    render() {
        this.resolveTimeAndResinSet();
        return (
            <Col lg={6} md={6} xs={12}>
                <Button
                    style={{ marginLeft: 10 }}
                    className='float-right'
                    variant="outlined"
                    onClick={() => {
                        this.lineReference.chartInstance.resetZoom()
                    }}>Reset Zoom</Button>
                <Button
                    style={{ marginLeft: 10 }}
                    className='float-right'
                    variant="outlined"
                    onClick={() => {
                        this.lineReference.chartInstance.ZoomOut()
                    }}>Zoom Out</Button>
                <Button className='float-right'
                        variant="outlined"
                        onClick={() => {
                            this.lineReference.chartInstance.ZoomIn()
                        }}>Zoom In</Button>
                <Scatter
                    id='ptru'
                    ref={(reference) => this.lineReference = reference}
                    data={printTimeAndResinUsageSet}
                    getElementAtEvent={element => {
                        if (element.length === 0) {
                            return
                        }
                        const index = element[0]._index;
                        const label = element[0]._chart.data.labels[index];
                        const value = element[0]._chart.data.datasets[0].data[index];
                        this.props.handleChartsClick({
                            chartType: MASTER_DASHBOARD_CHART_TYPE.PRINT_TIME_AND_RESIN_USAGE,
                            label,
                            value,
                        })
                    }}
                    options={{
                        animation: {
                            duration: 0
                        },
                        hover: {
                            animationDuration: 0
                        },
                        responsiveAnimationDuration: 0,
                        elements: {
                            line: {
                                tension: 0
                            }
                        },
                        title: {
                            display: true,
                            text: 'PrintTime/ResinUsage',
                            fontSize: 20
                        },
                        legend: {
                            display: false,
                        },
                        scales: {
                            gridLines: {
                                display: true
                            },
                            yAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: 'resin usage (ML)'
                                }
                            }],
                            xAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: 'print time (Min)'
                                }
                            }]
                        },
                        pan: {
                            enabled: true,
                            mode: 'xy',
                            rangeMin: {
                                x: 0,
                                y: 0
                            },
                            rangeMax: {
                                x: 1000,
                                y: 1000
                            },
                        },
                        zoom: {
                            enabled: true,
                            mode: 'xy',
                            rangeMin: {
                                x: 0,
                                y: 0
                            },
                            rangeMax: {
                                x: 1000,
                                y: 1000
                            },
                        },
                    }}
                />
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/print-data-print-time-and-resin-usage.js